module.exports = __webpack_public_path__ + "media/assets/community/logo-admissions-8427a099d60624ef5882a919bb5f4fdf4531b88a7bf825ab877a6e5d34220d1e.png";